import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 pt-20">
      <div className="container-custom py-20 text-center">
        <h1 className="text-7xl font-bold text-primary-500">404</h1>
        <h2 className="mt-4 text-2xl font-bold text-foreground-950">页面未找到</h2>
        <p className="mt-2 text-base text-foreground-500">
          您访问的页面不存在或已被移除
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            <i className="ri-home-line"></i>
            返回首页
          </Link>
          <Link
            to="/category/latest-urls"
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-800 rounded-full text-sm font-semibold hover:bg-background-200 transition-colors duration-200 whitespace-nowrap"
          >
            <i className="ri-link"></i>
            最新网址
          </Link>
        </div>
      </div>
    </div>
  );
}